import Button from "./Button";
import classNames from "./Error.module.css";

type ErrorProps = {
  errorMessage?: string;
  messageBody?: string;
};

const Error = (props: ErrorProps) => {
  return (
    <div className={classNames.Error}>
      <div className={classNames.ErrorMessage}>
        <h2>{props.errorMessage ?? "Something went wrong"}</h2>
        {props.messageBody && (
          <>
            <br />
            <h3>{props.messageBody}</h3>
          </>
        )}
      </div>
      <div className={classNames.ErrorButton}>
        <Button onClick={() => (window.location.href = "/")}>
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default Error;
